import { createContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAuthSlice,
  fetchingUserDetails,
} from "../../redux/slices/userSlice";
import { fetchUserData } from "../../redux/thunk/userThunk";
import Loader from "../../component/Loader";
import DataStorage from "../../utils/DataStorage";

export const isLogin = () => {
  const loginCheck = localStorage.getItem("accessToken");
  if (loginCheck) {
    return true;
  }
  return false;
};

export const isAuthenticated = () => {
  // Replace this with real authentication logic
  return !!localStorage.getItem("login");
};

export const CheckLoginUser = () => {
  const dispatch = useDispatch();
  const fetchingUserData = useRef(false);

  const fetchUserDetails = () => {
    dispatch(fetchingUserDetails(true));
    dispatch(fetchUserData());
  };

  useEffect(() => {
    if (isLogin()) {
      if (!fetchingUserData.current) {
        fetchingUserData.current = true;
        fetchUserDetails();
      }
    } else {
      dispatch(fetchingUserDetails(false));
      DataStorage.clear();
      dispatch(clearAuthSlice());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  const authState = useSelector((state) => state.user);
  const [auth] = useState();

  return (
    <AuthContext.Provider value={auth}>
      {authState.loading ? <Loader showLoader={true} /> : children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
